import { getAxiosClient } from '../../client';
import { makeApiRequest } from '../../makeApiRequest';
import type { ApiResponse } from '../../responses';
import { AuthEndpoints } from './authEndpoints';
import type { IAuthService } from './IAuthService';
import type {
    AuthLoginRequest,
    AuthLogoutRequest,
    AuthRefreshRequest,
} from './requests';
import type { AuthSessionResponse } from './responses';

type AuthServiceOptions = {
    baseUrl: string;
};

export class AuthService implements IAuthService {
    private readonly baseUrl: string;

    constructor({ baseUrl }: AuthServiceOptions) {
        this.baseUrl = baseUrl;
    }

    public login(
        body: AuthLoginRequest,
    ): Promise<ApiResponse<AuthSessionResponse>> {
        const url = AuthEndpoints.login();
        return makeApiRequest<AuthSessionResponse>(
            getAxiosClient({ baseURL: this.baseUrl }).post(url, body),
        );
    }

    public refresh(
        body: AuthRefreshRequest,
    ): Promise<ApiResponse<AuthSessionResponse>> {
        const url = AuthEndpoints.refresh();
        return makeApiRequest<AuthSessionResponse>(
            getAxiosClient({ baseURL: this.baseUrl }).post(url, body),
        );
    }

    public logout(body: AuthLogoutRequest): Promise<ApiResponse<void>> {
        const url = AuthEndpoints.logout();
        return makeApiRequest<void>(
            getAxiosClient({ baseURL: this.baseUrl }).post(url, body),
        );
    }
}
